/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Component, inject, input, OnInit, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { ScheduleItem } from '../../../shared/scheduling/models/schedule-item';
import { CurrentUserService } from '../../../user/services';
import { MonitorSchedule } from '../../models/monitor-schedule';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { FormsModule } from '@angular/forms';
import { ScheduleItemComponent } from '../../../shared/scheduling/schedule-item.component';
import { ChangeLogLinkComponent } from '../../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { RowValidatingEvent } from 'devextreme/ui/data_grid';

@Component({
  selector: 'app-monitor-schedules-grid',
  templateUrl: './monitor-schedules-grid.component.html',
  styleUrls: ['./monitor-schedules-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoPopupModule, DxoFormModule, DxiItemModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxTemplateModule, FormsModule, ScheduleItemComponent, DxiButtonModule, ChangeLogLinkComponent, ChangeLogLinkEntityDirective]
})
export class MonitorSchedulesGridComponent implements OnInit {
  private currentUserService = inject(CurrentUserService);

  public monitorSchedules = input<MonitorSchedule[]>([]);
  public deleteMonitorSchedule = output<MonitorSchedule>();
  public saveGroupMonitorSchedule = output<MonitorSchedule>();

  public allowAdding = signal(false);
  public allowUpdating = signal(false);
  public allowDeleting = signal(false);
  public allowShowLog = signal(false);

  ngOnInit(): void {
    this.allowAdding.set(this.currentUserService.hasPermission('Monitor_Action_Schedule_Create'));
    this.allowUpdating.set(this.currentUserService.hasPermission('Monitor_Action_Schedule_Edit'));
    this.allowDeleting.set(this.currentUserService.hasPermission('Monitor_Action_Schedule_Delete'));
    this.allowShowLog.set(this.currentUserService.hasPermission('Monitor_Action_ShowLog'));
  }

  onScheduleItemChange($event, cellInfo) {
    cellInfo.setValue($event);
  }

  onRowValidating($event: RowValidatingEvent): void {
    const newData = $event.newData as Partial<MonitorSchedule>;
    const oldData = $event.oldData as MonitorSchedule | undefined;

    const scheduledItem = (newData?.ScheduledItem ?? oldData?.ScheduledItem);

    const dateError = this.validateScheduleItem(scheduledItem);
    if (dateError) {
      $event.isValid = false;
      $event.errorText = dateError;
      return;
    }

    if (scheduledItem?.Triggers?.some(t => !t.Weekdays)) {
      $event.isValid = false;
      $event.errorText = 'All triggers must have at least one weekdays selected.';
      return;
    }
  }

  onInitNewRow(ev: any): void {
    const defaultSchedule = new ScheduleItem();
    const newDate = new Date();
    newDate.setHours(0, 0, 0, 0);
    defaultSchedule.StartDate = newDate;
    defaultSchedule.Enabled = true;
    const schedule = { Id: 0, Name: '', Description: '', ScheduledItem: defaultSchedule } as MonitorSchedule;
    ev.data = schedule;
  }

  onRowInserted(ev: any): void {
    const monitorSchedule = ev.data as MonitorSchedule;
    this.saveGroupMonitorSchedule.emit(monitorSchedule);
  }

  onRowUpdated(ev: any): void {
    const monitorSchedule = ev.data as MonitorSchedule;
    this.saveGroupMonitorSchedule.emit(monitorSchedule);
  }

  onRowRemoved(ev: any): void {
    const monitorSchedule = ev.data as MonitorSchedule;
    this.deleteMonitorSchedule.emit(monitorSchedule);
  }

  displayExprSchedule(e: any) {
    if (!e.value) {
      return '';
    }
    const item = e.value as ScheduleItem;
    if (item.Triggers.length > 0) {
      let returnstring = '';
      for (let i = 0; i < item.Triggers.length; i++) {
        if (item.Triggers.length > 1) {
          returnstring += '[ ';
        }
        returnstring += item.Triggers[i].StartTime;
        returnstring += ' - ';
        returnstring += item.Triggers[i].EndTime;
        returnstring += ': ';
        returnstring += item.Triggers[i].Weekdays;
        if (item.Triggers.length > 1) {
          returnstring += ' ] ';
        }
      }
      return returnstring;
    }
    return '';
  }

  private validateScheduleItem(si?: ScheduleItem | null): string | null {
    if (!si) return 'Schedule is missing.';
  
    if (!si.StartDate) {
      return 'Start date is required.';
    }
  
    const start = new Date(si.StartDate);
    const end = si.EndDate ? new Date(si.EndDate) : null;
  
    start.setHours(0, 0, 0, 0);
    if (end) end.setHours(0, 0, 0, 0);
  
    if (end && end < start) {
      return 'Expire date cannot be earlier than the start date.';
    }
  
    return null;
  }
}
